import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-veed-color-large.tsx
/**
* icon.24.logo.veed.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iOSIgZmlsbD0iIzMyMzIzMiIvPjxwYXRoIGZpbGw9IiNiNmZmNjAiIGQ9Ik0xNC44NTkgOC4wMjRjLjI2Ni0uMDQ0LjgxNSAwIDEuMTA0IDBxLjg1LS4wMDUgMS42OTkgMGMuMjUuMDAyLjU1LjAwNS43OTIgMGEyIDIgMCAwIDEtLjA0LjE5N2MtLjA2My4yOS0uMjkxLjc4NS0uNDEgMS4wOGwtLjk5MiAyLjQxMi0xLjUzNSAzLjc2M2MtLjIyMS41MjYtLjM3MSAxLjA4LS43MDIgMS41NS0uMzc4LjU0LTEuMDIyLjUwNC0xLjYxMi41MDZsLTEuMDk0LS4wMDEtMS4xMDcuMDAxYy0uODg3IDAtMS41MTQuMDU4LTEuOTM0LS44NTQtLjE4Ny0uNDA3LS4zMjYtLjgxNS0uNDk4LTEuMjI0bC0xLjQzNi0zLjUxMWMtLjQ2LTEuMTI4LS45NTItMi4yNDYtMS4zOTUtMy4zODJhMS40IDEuNCAwIDAgMS0uMDk5LS4zNzVsLS4wNC0uMTYyYy43Ny0uMDI0IDEuNTg1LjAwNyAyLjM2IDAgLjI4My0uMDAzIDEuMDY3LS4wNDQgMS4zMDQgMCAuMDM2LjAwMi4wODgtLjAyNy4xMTUgMGE3MCA3MCAwIDAgMSAuNzA4IDEuODIzYy4xMTQuMzMzLjI0NS42NTguMzY1Ljk4OC4yNzguNzYyLjU1NSAxLjUyMS44NTMgMi4yNzUuMTY0LjQxNy4zMTEuODM4LjQ3MSAxLjI1NS4wOTguMjU0LjIxNy40OTUuMjkyLjc1Ny4wNTQtLjIyNi4xNDktLjQxOS4yMTYtLjYzNi4yNS0uODEzLjU4NS0xLjU5Ny44ODctMi4zOTRsMS4yODEtMy40MjNjLjA3Ni0uMTk4LjE0Mi0uNDU1LjIxOC0uNjQ1LjA2NS0uMDEzLjE2Ni0uMDAyLjIyOSAwIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26876-63946
*/
const Icon24LogoVeedColorLarge = memo(function Icon24LogoVeedColorLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [/* @__PURE__ */ jsx("circle", {
			cx: "12",
			cy: "12",
			r: "9",
			fill: "#323232"
		}), /* @__PURE__ */ jsx("path", {
			fill: "#b6ff60",
			d: "M14.859 8.024c.266-.044.815 0 1.104 0q.85-.005 1.699 0c.25.002.55.005.792 0a2 2 0 0 1-.04.197c-.063.29-.291.785-.41 1.08l-.992 2.412-1.535 3.763c-.221.526-.371 1.08-.702 1.55-.378.54-1.022.504-1.612.506l-1.094-.001-1.107.001c-.887 0-1.514.058-1.934-.854-.187-.407-.326-.815-.498-1.224l-1.436-3.511c-.46-1.128-.952-2.246-1.395-3.382a1.4 1.4 0 0 1-.099-.375l-.04-.162c.77-.024 1.585.007 2.36 0 .283-.003 1.067-.044 1.304 0 .036.002.088-.027.115 0a70 70 0 0 1 .708 1.823c.114.333.245.658.365.988.278.762.555 1.521.853 2.275.164.417.311.838.471 1.255.098.254.217.495.292.757.054-.226.149-.419.216-.636.25-.813.585-1.597.887-2.394l1.281-3.423c.076-.198.142-.455.218-.645.065-.013.166-.002.229 0"
		})]
	});
});
//#endregion
export { Icon24LogoVeedColorLarge };

//# sourceMappingURL=icon-24-logo-veed-color-large.js.map